import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import api from "../lib/api";
import JobCard from "../components/demand/JobCard";
import TakeDialog from "../components/demand/TakeDialog";
import MyAllocations from "../components/demand/MyAllocations";
import NotificationSettings from "../components/demand/NotificationSettings";
import RepSummary from "../components/demand/RepSummary";
import { Briefcase, ClipboardList, BellRing } from "lucide-react";

function JobsGrid({ games, onTake, refresh }) {
  const [gameId, setGameId] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, page_size: 12 });
  useEffect(() => { api.get("/jobs", { params: { game_id: gameId || undefined, page } }).then((r) => setData(r.data)); }, [gameId, page, refresh]);
  const pages = Math.max(1, Math.ceil(data.total / data.page_size));
  return (
    <>
      {data.reputation && <RepSummary rep={data.reputation} />}
      <div className="flex flex-wrap gap-2 mb-6">
        {[{ id: "", name: "Semua Game" }, ...games].map((g) => (
          <button key={g.id || "all"} data-testid={`jobs-game-${g.id || "all"}`} onClick={() => { setGameId(g.id); setPage(1); }}
            className={`px-4 py-1.5 rounded-full text-xs border transition-colors ${gameId === g.id ? "bg-[#D4AF37] text-[#101114] border-[#D4AF37]" : "border-[#35353B] text-[#A8A8AD] hover:border-[#D4AF37]"}`}>{g.name}</button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {data.items.map((d, i) => <JobCard key={d.id} d={d} i={i} onTake={() => onTake(d.id)} />)}
      </div>
      {data.items.length === 0 && <div data-testid="jobs-empty" className="text-center py-20 text-[#A8A8AD]">Belum ada job terbuka. Aktifkan notifikasi agar tidak ketinggalan.</div>}
      {pages > 1 && <div className="flex justify-center items-center gap-3 mt-8 text-xs text-[#A8A8AD]">
        <button data-testid="jobs-prev" disabled={page <= 1} onClick={() => setPage(page - 1)} className="px-3 py-1 border border-[#35353B] rounded-sm disabled:opacity-30">‹</button>
        {page} / {pages}
        <button data-testid="jobs-next" disabled={page >= pages} onClick={() => setPage(page + 1)} className="px-3 py-1 border border-[#35353B] rounded-sm disabled:opacity-30">›</button></div>}
    </>
  );
}

export default function AvailableJobs() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "jobs";
  const takeId = params.get("job");
  const [games, setGames] = useState([]);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => { api.get("/games").then((r) => setGames(r.data)); }, []);
  const tabBtn = (key, label, Icon) => (
    <button data-testid={`jobs-tab-${key}`} onClick={() => setParams({ tab: key })}
      className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${tab === key ? "border-[#D4AF37] text-[#D4AF37]" : "border-transparent text-[#A8A8AD] hover:text-[#F5F3ED]"}`}>
      <Icon size={15} /> {label}
    </button>
  );
  return (
    <div className="min-h-screen bg-[#101114]">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-10">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#D4AF37] mb-2">SUPPLIER · FIRST COME, FIRST SERVED</div>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#F5F3ED] mb-8" style={{ fontFamily: "'Playfair Display', serif" }}>Available Jobs</h1>
        <div className="flex gap-1 mb-8 border-b border-[#35353B] overflow-x-auto">
          {tabBtn("jobs", "Available Jobs", Briefcase)}{tabBtn("mine", "Alokasi Saya", ClipboardList)}{tabBtn("settings", "Notification Settings", BellRing)}
        </div>
        {tab === "jobs" && <JobsGrid games={games} refresh={refresh} onTake={(id) => setParams({ tab: "jobs", job: id })} />}
        {tab === "mine" && <MyAllocations />}
        {tab === "settings" && <NotificationSettings games={games} />}
      </div>
      {takeId && <TakeDialog id={takeId} onClose={() => setParams({ tab })} onTaken={() => { setRefresh((x) => x + 1); setParams({ tab: "mine" }); }} />}
    </div>
  );
}
